import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { financeQueryKeys } from '@/common/queryKeys/finance';
import { ItemFinancialsApi } from '@/features/financials/api/item-financials';

export const useItemFinancialsQuery = (itemIds: number[], options: { enabled?: boolean } = {}) => {
  return useQuery({
    queryKey: financeQueryKeys.itemFinancials.bulk(itemIds),
    queryFn: ({ signal }) =>
      ItemFinancialsApi.bulkGetItemFinancials(
        [...itemIds].sort((a, b) => a - b),
        signal,
      ),
    enabled: (options.enabled ?? true) && itemIds.length > 0,
    placeholderData: keepPreviousData,
  });
};
